import { useMutation } from "@apollo/client";
import {
  IonButton,
  IonButtons,
  IonCardSubtitle,
  IonContent,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonList,
  IonListHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  useIonModal,
} from "@ionic/react";
import InputModal from "components/InputModal/InputModal";
import { AuthContext } from "contexts/AuthContext";
import { UPDATE_USER } from "graphql/mutations";
import useAccount from "hooks/useAccount";
import { chevronBackOutline } from "ionicons/icons";
import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { AccountStore } from "stores/AccountStore";
import "./Personal.css";

const Personal = () => {
  const { authState } = useContext(AuthContext);
  const history = useHistory();
  const [field, setField] = useState("");
  const account = AccountStore.useState((s) => s.account);
  const [fetchAccount, { data }] = useAccount(authState);
  const [changed, setChanged] = useState({});

  const handleDismiss = () => {
    dismiss();
  };

  const [present, dismiss] = useIonModal(InputModal, {
    account,
    refetchAccount: fetchAccount,
    field,
    onDismiss: handleDismiss,
  });

  const openModal = (name) => {
    setField(name);
    present({
      id: name + "-input-modal",
      keyboardClose: false,
    });
  };

  const [updateUser] = useMutation(UPDATE_USER);

  const onChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setChanged((prevState) => {
      return { ...prevState, [name]: value };
    });
  };

  const onSave = async () => {
    if (changed.phone) changed["phone"] = changed.phone.replace(/[^0-9]/g, "");

    const payload = {
      variables: {
        id: account?.id,
        user: {
          ...changed,
        },
      },
    };

    await updateUser(payload);
    await fetchAccount();
  };

  useEffect(() => {
    if (data?.users_by_pk)
      AccountStore.update((s) => {
        s.account = { ...data.users_by_pk };
      });
  }, [data]);

  return (
    <IonPage className={"personal-page-root"}>
      <IonHeader className={"ion-no-border"}>
        <IonToolbar className={"background-color"}>
          <IonButtons slot="start">
            <IonButton onClick={() => history.goBack()}>
              <IonIcon icon={chevronBackOutline} color="dark" size="large" />
            </IonButton>
          </IonButtons>
          <IonTitle>Personal</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonList lines="none">
          <IonListHeader>
            <IonCardSubtitle>Full Name</IonCardSubtitle>
          </IonListHeader>
          <IonItem>
            <IonInput
              type="text"
              placeholder="Add name"
              name="name"
              value={
                typeof changed?.name !== "undefined"
                  ? changed.name
                  : account?.name
              }
              onIonChange={(e) => onChange(e)}
              onIonBlur={() => onSave()}
            ></IonInput>
          </IonItem>
          <IonListHeader>
            <IonCardSubtitle>OshiTag</IonCardSubtitle>
          </IonListHeader>
          <IonItem onClick={() => openModal("username")}>
            <p>{account?.username || "Add username"}</p>
          </IonItem>
          <IonListHeader>
            <IonCardSubtitle>Bio</IonCardSubtitle>
          </IonListHeader>
          <IonItem onClick={() => openModal("bio")}>
            <p>{account?.bio || "Add bio"}</p>
          </IonItem>
          <IonListHeader>
            <IonCardSubtitle>Personal</IonCardSubtitle>
          </IonListHeader>
          <IonItem>
            <IonInput
              type="tel"
              placeholder="Add phone"
              name="phone"
              onIonChange={(e) => onChange(e)}
              onIonBlur={() => onSave()}
              value={
                typeof changed?.phone !== "undefined"
                  ? changed.phone
                  : account?.phone
              }
            ></IonInput>
          </IonItem>
          <IonItem>
            <IonInput
              type="text"
              placeholder="Add email"
              value={account?.email}
              readonly
            ></IonInput>
          </IonItem>
        </IonList>
      </IonContent>
    </IonPage>
  );
};

export default Personal;
